<div *ngIf="(hasProject$ | async) !== true" class="card">
	<nz-alert
		nzType="warning" nzShowIcon
		nzMessage="{{ 'message.warning.project.noneLoaded.title' | translate }}"
		nzDescription="{{ 'message.warning.project.noneLoaded.description' | translate }}"
	></nz-alert>
</div>
<div *ngIf="privacyMode$ | async" class="card">
	<nz-alert nzType="warning" nzShowIcon
		nzMessage="{{ 'message.warning.privacy_protection.title' | translate }}"
		nzDescription="{{ 'message.warning.privacy_protection.description' | translate }}"
	></nz-alert>
</div>

<nz-card>
	<div class="toolbar">
		<app-search [autofocus]="true" (searchResults)="searchResult$.next($event)" 
					(isLoading)="searchResult$.next(null)"></app-search>
		<div class="actions">
			<app-splitbutton [appBulkActionsProvider]="(checkedParticipants$ | async) || []" appElementCollector></app-splitbutton>
			<app-select-exports-button *ngIf="exportButtonViewState$ | async as conf"
				[listOfSelectedParticipants]="conf.selected"
				[exportConfigs]="conf.configurations"
				[totalNumberOfParticipants]="conf.participantCount"
				sourceWindow="participantWorkflowOverview"
			>
			</app-select-exports-button>
			<app-splitbutton *ngIf="showParticipantAdd$ | async"
				[elements]="[participantAddSplitButton]"
			></app-splitbutton>
		</div>
	</div>

	<nz-table #dynamicTable *ngIf="tableViewState$ | async as table; else: loading" [nzData]="table.participants" [nzBordered]="table.props.bordered"
			[nzSimple]="table.props.simple" [nzPaginationPosition]="table.props.position" [nzShowSizeChanger]="table.props.sizeChanger"
			[nzFrontPagination]="table.props.pagination" [nzShowPagination]="table.props.pagination" [nzPageSize]="table.props.pageSize"
			[nzSize]="table.props.size"
			class="kit__utils__table">
		<thead>
			<tr *ngIf="table.props.header">
				<th [nzChecked]="table.selectionState === 'all'"
					[nzIndeterminate]="table.selectionState === 'some'"
					(nzCheckedChange)="onAllChecked($event)"></th>
				<th nzCustomFilter [nzSortFn]="comparePseudonym">
					{{'Pseudonym'}}
					<nz-filter-trigger [nzActive]="pseudoFilterInput.value.length > 0" [nzDropdownMenu]="menu">
						<i nz-icon nzType="filter"></i>
					</nz-filter-trigger>
					<nz-dropdown-menu #menu="nzDropdownMenu">
						<div class="ant-table-filter-dropdown">
							<div class="search-box">
								<input #pseudoFilterInput type="text" nz-input (change)="pseudonymFilter$.next(pseudoFilterInput.value)"
									placeholder="{{ 'actions.searchFor' | translate : { searchItem : 'Pseudonym' } }}" />
							</div>
						</div>
					</nz-dropdown-menu>
				</th>
				<th *ngFor="let column of table.columns" [nzWidth]="'130px'" [nzAlign]="'center'">{{column.header}}</th>
			</tr>
		</thead>
		<tbody>
			<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
				<tr>
					<td
						[nzChecked]="participantSelectionModel.isSelected(data.id)"
						[nzDisabled]="data.disabled"
						(nzCheckedChange)="participantSelectionModel.toggle(data.id)"
					>
					</td>
					<td (click)="showParticipantProfil(data)" [class.newestParticipant]="data.id === table.newestParticipantId">{{ data.pseudonym }}</td>
					<td *ngFor="let column of table.columns">
						<button wfsBadge [appWfsStatusBadge]="column.id" [status]="data.workflowStatus?.status[column.id]" (click)="navigateToWorkflowDetail(data, column.id)"></button>
					</td>
				</tr>
			</ng-template>
		</tbody>
	</nz-table>
	<ng-template #loading>
		<nz-spin nzSimple></nz-spin>
	</ng-template>
</nz-card>
